import * as React from 'react';
import { memo } from 'react';
import { DatePicker, Form, FormInstance, Row, Space } from 'antd';
import Button from '/react4xp/mixins/ui/button/button';
import { DeleteFormValues } from '../../admin-knowledge-base.type';
import { disabledDate } from '../../admin-knowledge-base.utils';

interface DeleteFormProps {
    onSubmit: (values: DeleteFormValues) => void;
    close: () => void;
    form: FormInstance<DeleteFormValues>;
}

export const DeleteForm = memo(({ onSubmit, close, form }: DeleteFormProps) => {
    const effective = Form.useWatch('effective', form);

    return (
        <Form
            form={form}
            onFinish={onSubmit}
        >
            <Form.Item
                hidden
                name="id"
            />
            <Form.Item
                name="effective"
                label="Запланировать удаление"
                labelCol={{ span: 24 }}
            >
                <DatePicker
                    picker="date"
                    disabledDate={disabledDate}
                    format={'DD.MM.YYYY'}
                />
            </Form.Item>
            <Row justify="end">
                <Space>
                    <Form.Item>
                        <Button onClick={close}>Отменить</Button>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            htmlType="submit"
                            color="gold"
                        >
                            {effective ? 'Запланировать' : 'Удалить'}
                        </Button>
                    </Form.Item>
                </Space>
            </Row>
        </Form>
    );
});
